// Imrpoved version, version on staging. Currently working pretty well.

import { useState, useEffect } from "react";
import PortfolioCategories from "../../components/PortfolioCategories.jsx";
import ProjectDetails from "../../components/ProjectDetails.jsx";
import projectsData from "../../projects.json";
import ProjectThumbnailsV2Grid from "../../components/ProjectThumbnailsV2Grid.jsx";
import "./PortfolioV2.css";

const PortfolioV2 = () => {
  const [selectedCategory, setSelectedCategory] = useState("UX Design");
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const displayLimit = 11;

  useEffect(() => {
    setProjects(projectsData);
  }, []);

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const handleProjectClick = (project) => {
    if (selectedProject && selectedProject.id === project.id) {
      setSelectedProject(null);
    } else {
      setSelectedProject(project);
    }
  };

  return (
    <div className="mt-32 portfolio-container">
      <PortfolioCategories
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
      />
      <div style={{ height: "20px" }}></div>
      <div className="portfolio-grid">
        <ProjectThumbnailsV2Grid
          projects={filteredProjects.slice(0, displayLimit)}
          onProjectClick={handleProjectClick}
        />
      </div>
      <div style={{ height: "20px" }}></div>
      {selectedProject && (
        <ProjectDetails
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </div>
  );
};

export default PortfolioV2;
